/**
 * @desc 审批
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.FirstApproveRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/wms/firstTrialOrder/approve`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
